export default __webpack_public_path__ + "static/media/ab_club.9cfcaf9f.svg";